const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
const TOKEN_KEY = 'dca_access_token';
const USER_KEY = 'dca_user';

const demoSubjects = [
  { id: 1, registrationNo: 'CN-2026-0142', name: '김영희', birthYear: 1942, gender: 'F', status: 'ACTIVE', managerName: '박은지', updatedAt: '2026-07-24T01:20:00.000Z' },
  { id: 2, registrationNo: 'CN-2026-0138', name: '이정수', birthYear: 1938, gender: 'M', status: 'ACTIVE', managerName: '김민호', updatedAt: '2026-07-23T06:10:00.000Z' },
  { id: 3, registrationNo: 'CN-2026-0127', name: '최순자', birthYear: 1946, gender: 'F', status: 'HOLD', managerName: '박은지', updatedAt: '2026-07-21T09:30:00.000Z' },
  { id: 4, registrationNo: 'CN-2026-0119', name: '정○○', birthYear: 1940, gender: 'U', status: 'CLOSED', managerName: '김민호', updatedAt: '2026-07-18T08:00:00.000Z' },
];

const demoStats = {
  activeSubjects: 148,
  monthlyPlans: 18,
  completionRate: 82,
  overdueCases: 3,
  statusSeries: [
    { label: '1월', value: 9 }, { label: '2월', value: 12 }, { label: '3월', value: 11 },
    { label: '4월', value: 15 }, { label: '5월', value: 14 }, { label: '6월', value: 18 },
  ],
  serviceSeries: [
    { label: '인지활동', value: 34 }, { label: '가족지원', value: 25 },
    { label: '일상생활', value: 21 }, { label: '안전관리', value: 20 },
  ],
};

function storedSession() {
  try {
    const token = sessionStorage.getItem(TOKEN_KEY);
    const user = JSON.parse(sessionStorage.getItem(USER_KEY) || 'null');
    return token && user ? { token, user } : null;
  } catch {
    return null;
  }
}

async function request(path, options = {}) {
  const session = storedSession();
  const response = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(session?.token ? { Authorization: `Bearer ${session.token}` } : {}),
      ...options.headers,
    },
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.message || '요청을 처리하지 못했습니다.');
  return data;
}

function saveSession(session) {
  sessionStorage.setItem(TOKEN_KEY, session.token);
  sessionStorage.setItem(USER_KEY, JSON.stringify(session.user));
  return session;
}

export const portalApi = {
  session: storedSession,
  async login(credentials) {
    try {
      return saveSession(await request('/auth/login', { method: 'POST', body: JSON.stringify(credentials) }));
    } catch (error) {
      if (credentials.email !== 'admin@demo.local' || credentials.password !== 'Demo1234!') throw error;
      return saveSession({
        token: 'offline-demo-token',
        user: { id: 1, institutionId: 1, institution: '충청남도광역치매센터', email: credentials.email, name: '김민호', role: 'SUPER_ADMIN' },
      });
    }
  },
  logout() {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(USER_KEY);
  },
  async subjects(search = '') {
    try { return await request(`/subjects?search=${encodeURIComponent(search)}`); }
    catch { return demoSubjects.filter((item) => `${item.name} ${item.registrationNo}`.includes(search)); }
  },
  async createSubject(subject) {
    try { return await request('/subjects', { method: 'POST', body: JSON.stringify(subject) }); }
    catch { return { id: Date.now(), ...subject, status: 'ACTIVE', managerName: '김민호', updatedAt: new Date().toISOString() }; }
  },
  async stats() {
    try { return await request('/stats/overview'); } catch { return demoStats; }
  },
  async users() {
    try { return await request('/users'); }
    catch {
      return [
        { id: 1, name: '김민호', email: 'admin@demo.local', institution: '충청남도광역치매센터', role: 'SUPER_ADMIN', active: true },
        { id: 2, name: '박은지', email: 'manager@demo.local', institution: '충청남도광역치매센터', role: 'CASE_MANAGER', active: true },
        { id: 3, name: '최현우', email: 'viewer@demo.local', institution: '충청남도광역치매센터', role: 'VIEWER', active: false },
      ];
    }
  },
};
